module.exports = __webpack_public_path__ + "media/svg/selection_fond_fr_2-04a79487.svg";